import { Component, Output, EventEmitter, OnInit, NgModule } from '@angular/core';
import { PanelService } from 'src/app/panel/services/panel.service';
import { BrowserModule } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { HttpClient } from '@angular/common/http';
import { EventService } from 'src/app/events/services/event.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { GeopointsService } from 'src/app/geopoints/services/geopoints.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { CircularGeofencesService } from 'src/app/geofences/services/circular-geofences.service';
import { filter } from 'lodash';
@Component({
  selector: 'app-user-password-update',
  templateUrl: './user-password-update.component.html',
  styleUrls: ['./user-password-update.component.scss']
})
export class UserPasswordUpdateComponent implements OnInit {


  userInfoForm :any = {};

  isUnderConstruction: boolean = true;
  loading : boolean = false;

  showEventos: boolean = false;
  showReportes: boolean = false;
  cities = [
    {name: 'New York', code: 'NY', inactive: false},
    {name: 'Rome', code: 'RM', inactive: true},
    {name: 'London', code: 'LDN', inactive: false},
    {name: 'Istanbul', code: 'IST', inactive: true},
    {name: 'Paris', code: 'PRS', inactive: false},
    {name: 'PERU', code: 'PE', inactive: false},
    {name: 'Mexico', code: 'ME', inactive: false},
    {name: 'Paraguay', code: 'Pa', inactive: false},
    {name: 'India', code: 'In', inactive: false},
    {name: 'Turkia', code: 'In', inactive: false},
    {name: 'Japon', code: 'In', inactive: false},
    {name: 'Islandia', code: 'In', inactive: false},

  ];
  reports: any;
  events: any;
  email_user: string = '';
  company_name: string = '';
  constructor(
    public userDataService: UserDataService,
    private panelService: PanelService,
    private http: HttpClient,
    private geopointsService: GeopointsService,
    private vehiclesService: VehicleService,
    private geofencesService: GeofencesService,
    private geoCircularService: CircularGeofencesService,
    private EventService: EventService) {
  }

  async ngOnInit(): Promise<void> {
    this.userDataService.spinner.show('loadingInfoUser'); // Nombre opcional, puedes usarlo para identificar el spinner
    this.initForm();

  }

  initForm() {
    this.userInfoForm.changePass = false;
    this.userInfoForm.oldPass = '';
    this.userInfoForm.newPass = '';
    this.userInfoForm.newPassRepeat = '';
    this.userInfoForm.eventosLenght = '0';
    this.userInfoForm.reportesLenght = '0';
  }

  onClickCancel(){
    this.userInfoForm.oldPass = '';
    this.userInfoForm.newPass = '';
    this.userInfoForm.newPassRepeat = '';
    $("#panelMonitoreo").hide( "slow" );
  }

  async onSubmit(){
    // Limpiar el array antes de agregar los datos actualizados

    console.log(this.userInfoForm); // Información del formulario general


    // Preparación de la solicitud para enviar datos
    let req = {
      oldPass: this.userInfoForm.oldPass,
      newPass: this.userInfoForm.newPass,
      newCopyPass: this.userInfoForm.newPassRepeat,
    };
    return req;
  }

  confirm(){
    console.log("render cambiar contraseña")
    this.loading=true;
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Se aplicarán los cambios',
      //icon: 'warning',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        actions: 'w-100',
        cancelButton: 'col-4',
        confirmButton: 'col-4',
      },
      preConfirm: async () => {
        var req:any;
        req = await this.onSubmit();
        this.userDataService.changePasswordUser(req).subscribe(
          (response) => {
            // Manejar la respuesta del servidor si es necesario
            // console.log('Actualización exitosa:', response);
            if (!response.res){
              Swal.fire(
                'Ups',
                response.message,
                'warning'
              );
            }else if (response.res){
              Swal.fire(
                '',
                'Los datos se guardaron correctamente!!',
                'success'
              );
            }
          },
          (error) => {
            // Manejar errores si la actualización falla
            console.error('Error al actualizar:', error);
            Swal.fire(
              'Error',
              'Ocurrió un error...',
              'warning'
            );
          }
        );
      },
    }).then((data) => {
      // console.log('testing respuesta...',data);
      this.loading=false;
    });
  }
  userName: string='';
}
